export function readFileAsync(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = () => {
       const blob = new Blob([reader.result as BlobPart], { type: file.type });
       const url = URL.createObjectURL(blob)
       resolve(url)
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
}
